export default __webpack_public_path__ + "static/media/about.3b312a47.jpg";